import { socialServiceRunnersOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { usersToMemberEdit } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("social-service-runners"),
  endpoint: "social-service-runners",
  operations: socialServiceRunnersOps,
  roleView: [ROLE.USER_VIEW, ROLE.USER_ADMIN],
  roleAdmin: [ROLE.USER_ADMIN],
  singularName: (t) => t("Social service runner"),
  name: (t) => t("Social service runners"),
  infiniteNormalizer: (value) => ({
    rowCount: value.rowCount,
    first: value.first,
    results: usersToMemberEdit(value.results ?? []),
  }),
  sendCulture: true,
  dependencies: ["contract"],
  syncCustomerFilter: true,
});

export default conf;
